import { Component, OnInit, ViewChild } from '@angular/core';
import { Observable, Subject, timer, EMPTY } from 'rxjs';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { RestService } from '../_servicos/rest.service';
import { ServidorService } from '../_servicos/servidor.service';
import { ModalAlertaService } from '../shared/modal-alerta.service';
import { ModalAjudaService } from '../shared/modal-ajuda.service';
import { tap, take, catchError } from 'rxjs/operators';
import { Util } from '../_classes/util';
import { Proad } from '../_classes/proad';
import { EnvService } from '../_servicos/env.service';
import { UtilLogAcessoSistema } from '../_classes/util-log-acesso-sistema';

@Component({
  selector: 'app-proad',
  templateUrl: './proad.component.html',
  styleUrls: ['./proad.component.scss'],
})
export class ProadComponent implements OnInit {
  private readonly recurso: string = 'proad'; //mesmo que a rota
  carregando = false;
  mostrarArquivados = false;

  displayedColumns: string[] = [
    'dtCadastro',
    'nrProtocolo',
    //'nrAno',
    'dsObs', //descricao
    'dsIcone', //situacao
    'dsLink',
  ];

  //servidor$: Observable<Servidor>;
  //servidor: Servidor = new Servidor();

  erros$ = new Subject<boolean>();
  dataSource$: Observable<Proad[]>;
  dataSource: MatTableDataSource<Proad>;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  itensAjuda = [
    {
      titulo: 'Dt  Cadastro',
      texto:
        'Data em que o processo foi protocolado  (exceto quando dependeu de autorização).',
    },
    {
      titulo: 'Nr',
      texto: 'Número/Ano do processo Proad',
    },
    {
      titulo: 'Descrição',
      texto: 'Assunto do processo e resumo',
    },
    {
      titulo: 'Situação',
      texto: 'Última ação no processo, e localidade',
    },
  ];

  private t: any;

  ngOnDestroy() {
    if (this.t) {
      this.t.unsubscribe();
    }
  }

  constructor(
    private service: RestService,
    private servService: ServidorService,
    private alertService: ModalAlertaService,
    private ajudaService: ModalAjudaService,
    private env: EnvService
  ) {}

  ngOnInit() {
    this.atualizar();
  }

  dataFormatada(d: Date) {
    return Util.dataMesAbrev(d);
  }

  link(nr: number, ano: number): string {
    return (
      'https://adm.trt24.jus.br/proad/f/t/fichaprocessoman?nrProtocolo=' +
      nr +
      '&nrAno=' +
      ano +
      '&evento=y'
    );
  }

  //executarAoCarregarServidor(x: Servidor) {    this.servidor = new Servidor(x);  }

  alterarMostrarArquivados() {
    this.atualizar();
  }

  executarAoCarregarDatasource(x: Proad[]) {
    this.dataSource = new MatTableDataSource<Proad>(x);
    if (this.dataSource) {
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.dataSource.sortingDataAccessor = this.sortingDataAccessor;
    }
    this.carregando = false;
  }

  sortingDataAccessor(item, property) {
    if (property.includes('.')) {
      return property.split('.').reduce((object, key) => object[key], item);
    }
    return item[property];
  }
  /*
  atualizar() {
    this.carregando = true;
    this.t = timer(20000).subscribe((v) => {
      if (this.carregando) {
        this.carregando = false;
        this.handleError(
          'Excedido tempo de carregamento (' + this.constructor.name + ')'
        );
      }
    });

    this.servidor = this.servService.getServidorAtualRedirecionando('lotacao');
    //console.log('this.servidor', this.servidor, this.mostrarArquivados);
    if (!this.servidor) {
      this.servidor$ = this.servService.getServidor().pipe(
        tap((x) => this.executarAoCarregarServidor(x)),
        take(1),
        catchError((e) => {
          this.handleError(e);
          return EMPTY;
        })
      );
    }
    if (this.servidor) {
      this.dataSource$ = this.service
        .listarProadPush(
          this.servidor.usuario.idUsuario,
          this.mostrarArquivados ? 1 : 0
        )
        .pipe(
          tap((a) => this.executarAoCarregarDatasource(a)),
          take(1),
          catchError((e) => {
            this.handleError(e);
            return EMPTY;
          })
        );
    }
  }
  */

  atualizar() {
    this.carregando = true;

    this.t = timer(20000).subscribe((v) => {
      if (this.carregando) {
        this.carregando = false;
        this.handleError(
          'Excedido tempo de carregamento (' + this.constructor.name + ')'
        );
      }
    });

    if (this.env.servidor) {
      this.listar();
    } else {
      //this.servService.getServidorComFuncao(() => {this.listar();});
      this.servService.getServidorComFuncao2().then(() => this.listar());
    }
  }

  listar() {
    UtilLogAcessoSistema.registrarAcessoAoRecurso(
      this.recurso,
      this.env.servidor.idServidor,
      this.service
    );

    this.dataSource$ = this.service
      .listarProadPush(
        this.env.servidor.usuario.idUsuario,
        this.mostrarArquivados ? 1 : 0
      )
      .pipe(
        tap((a) => this.executarAoCarregarDatasource(a)),
        take(1),
        catchError((e) => {
          this.handleError(e);
          return EMPTY;
        })
      );
  }

  qualIconeMostrar(str: string) {
    return this.avaliarDsIcone(str, 'I');
  }
  mostrarIcone(str: string) {
    return this.avaliarDsIcone(str, 'B');
  }
  qualHintMostrar(str: string) {
    return this.avaliarDsIcone(str, 'H');
  }

  avaliarDsIcone(str: string, retorno: string) {
    /* tipos de retorno I-Icone, B-Boolean, H-Hint */
    if (
      str.startsWith('Arquivado em') ||
      str.startsWith('Auto arquivado em') ||
      str.startsWith('Encerrada movimentação')
    ) {
      return retorno === 'B'
        ? true
        : retorno === 'I'
        ? './assets/imagens/proad-arquiva.gif'
        : 'Arquivado';
    } else {
      if (str.startsWith('Pendente de análise para')) {
        return retorno === 'B'
          ? true
          : retorno === 'I'
          ? './assets/imagens/proad-pendente-de-analise.gif'
          : 'Pendente';
      } else {
        if (str.startsWith('Em análise na(o)')) {
          return retorno === 'B'
            ? true
            : retorno === 'I'
            ? './assets/imagens/proad-em-analise.gif'
            : 'Em análise';
        } else {
          return retorno === 'B' ? false : '';
        }
      }
    }
  }

  periodo(dI: Date, dF: Date) {
    return Util.periodoMesAbreviado(dI, dF);
  }
  dataStr(d: Date) {
    return Util.dataMesAbrev(d);
  }

  aplicarFiltro(event: Event) {
    //console.log(event);
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  mostrarAjudaModal() {
    this.ajudaService.mostrar(this.itensAjuda, '');
  }

  handleError(e: any) {
    this.erros$.next(true);
    this.alertService.mostrarAlertaPerigo(
      'Erro, tente novamente mais tarde',
      e
    );
  }
}
